import { useApi } from '../../hooks/useApi.js';

/**
 * Pick a client by name from Blake's client list (Joe, 15 Oct 2026: the
 * sample label's client should come from a dropdown, not be typed). The
 * value is the client's name, as printed; a name that isn't in the list
 * (an older label) stays selectable.
 */
const baseStyle = {
  padding: '8px 11px', borderRadius: 'var(--radius)', border: '1px solid var(--border)', fontSize: 14,
  background: 'var(--surface-2)', width: '100%', boxSizing: 'border-box', color: 'var(--text)', fontFamily: 'inherit',
};

export default function ClientSelect({ value = '', onChange, placeholder = '— No client —', style }) {
  const { data } = useApi('/clients?limit=200&is_active=true');
  const list = (Array.isArray(data) ? data : data?.clients ?? data?.data ?? []).map((c) => c.name).filter(Boolean);
  const names = value && !list.includes(value) ? [value, ...list] : list;
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} style={{ ...baseStyle, ...style }}>
      <option value="">{placeholder}</option>
      {names.map((n) => <option key={n} value={n}>{n}</option>)}
    </select>
  );
}
